import { getApolloClient } from 'lib/network/apollo';
import { registryGraphqlUrl } from 'lib/config';

export default getApolloClient(registryGraphqlUrl);